//=========================================================================================================================
//  there are 3 types of funcitons are written here to handle api call and mobx store.

//      type-1: functions which are called from code.
//              these function handle paylods, success and fail funcitons
//              and calles a funciton which will hit api.

//      type-2: functions which update mobx states.

//      type-3: functions which will hit api throuth apiclient.
//=========================================================================================================================

import { makeAutoObservable } from "mobx";
import {
  getBlobToBase64,
  getDecodedToken,
  getFileSize,
} from "../utils/functions";
import apiClient, { plainApiClient } from "../api";
import { settingsMenuDetails } from "../utils/constants";
import AuthStore from "./AuthStore";
import UserStore from "./UserStore";
import { makePersistable, isHydrated } from "mobx-persist-store";
import { customStorage } from "../utils/customStorage";
import ProfileStore2 from "./ProfileStore2";

class SettingsStore {
  profile = null;
  tempProfileForUpdate = null;
  familyMemberAccessData = null;
  familyMemberAccessImages = null;
  liaisonOfficerData = null;
  liaisonOfficerImages = null;
  addLiaisonOfficerUrl = "";
  registeredDevices = null;
  recentLogin = null;
  recentLoginImages = null;
  isNotification = "0";
  investmentHeldWith = null;
  isheldaway = null;
  report_type = 0;
  settingsOptionsArr = [];
  loginFromUserList = [];
  loginFromCheckedIds = {};
  byDevicesFilterSelected = { apple: true, android: true, others: true };

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "settings",
      properties: [
        "profile",
        // "tempProfileForUpdate",
        "familyMemberAccessData",
        "familyMemberAccessImages",
        "liaisonOfficerData",
        "liaisonOfficerImages",
        "addLiaisonOfficerUrl",
        "registeredDevices",
        "recentLogin",
        // "recentLoginImages",
        "isNotification",
        "investmentHeldWith",
        "report_type",
        "settingsOptionsArr",
        "loginFromUserList",
        "loginFromCheckedIds",
        "byDevicesFilterSelected",
      ],
      storage: customStorage,
      expireIn: 86400000, // One day in milliseconds
      removeOnExpiration: true,
      stringify: false,
    });
  }

  // a function to get all required data at once when settings component mounts
  // type-1 funcitons states from here.
  populateSettingsData() {
    let userId;
    if (getDecodedToken()?.user_type === "employee") {
      userId = UserStore?.userData?.user_id;
    } else {
      userId = getDecodedToken()?.user_id;
    }
    const { user_type, primary } = getDecodedToken();

    if (user_type === "customer" && primary === "true") {
      this.callGetFamilyMemberAccessData({
        onDataSuccess: (data) => {},
        onDataFail: (error) => {},
      });
      this.getLaisonOfficersData({
        clientId: userId,
        onSuccess: (data) => {
          if (!data.length) {
            this.liaisonOfficerData = null;
          }
          const imageArr = {};
          if (!data.length) {
            this.liaisonOfficerData = null;
          }
          if (data[0].profile.profile_pic) {
            this.getImageFromAPI({
              path: data[0].profile.profile_pic,
              onSuccess: (imageRawData) => {
                getBlobToBase64(imageRawData).then((url) => {
                  let resImage = url;
                  imageArr[data[0].profile.user_id] = resImage;
                  this.profile = {
                    name: data[0].profile.profile_pic.slice(
                      data[0].profile.profile_pic.lastIndexOf("/") + 1
                    ),
                    size: getFileSize(imageRawData?.size),
                    exactSize: imageRawData?.size,
                    type: imageRawData?.type,
                    src: resImage,
                    file: imageRawData,
                  };
                  this.liaisonOfficerImages = {
                    ...this.liaisonOfficerImages,
                    ...imageArr,
                  };
                });
              },
            });
          }
          data[0]?.accountAccess?.forEach((eachClient) => {
            if (eachClient.client.profile_pic) {
              this.getImageFromAPI({
                path: eachClient.client.profile_pic,
                onSuccess: (imageBlob) => {
                  getBlobToBase64(imageBlob).then((url) => {
                    let resImage = url;
                    imageArr[eachClient.client.user_id] = resImage;
                    this.liaisonOfficerImages = {
                      ...this.liaisonOfficerImages,
                      ...imageArr,
                    };
                  });
                },
              });
            }
          });
          this.liaisonOfficerData = data[0];
        },
        loader: true,
      });
    }

    this.getClientData({
      clientId: userId,
      onSuccess: (data) => {
        this.isNotification = Number(data.isNotification);
        this.investmentHeldWith = data.investmentHeldWith;
        this.report_type = data.reportType;

        if (UserStore.isSelectedUserPrimary) {
          this.isheldaway = data.isheldawayfamily;
        } else {
          this.isheldaway = data.isheldaway;
        }
      },
    });

    if (user_type === "customer") {
      this.getRegisteredDevices({
        clientId: userId,
        onSuccess: (data) => {
          this.registeredDevices = data;
        },
      });

      this.getRecentLogin({
        clientId: userId,
        onSuccess: (data) => {
          this.recentLogin = data;
          let userData = [];
          data?.forEach((eachData) => {
            if (
              !userData?.find(
                (usersData) =>
                  usersData.user?.user_id === eachData?.user?.user_id
              )
            )
              userData.push(eachData);
          });
          if (userData.length) {
            let imageArr = {};
            this.recentLoginImages = null;
            userData?.forEach((eachClient) => {
              if (eachClient.user?.profile_pic) {
                ProfileStore2.getImageFromAPIProfile({
                  path: eachClient.user.profile_pic,
                  onSuccess: (imageBlob) => {
                    getBlobToBase64(imageBlob).then((url) => {
                      let resImage = url;
                      imageArr[eachClient.user.user_id] = resImage;
                      this.recentLoginImages = {
                        ...this.recentLoginImages,
                        ...imageArr,
                      };
                    });
                  },
                  onFail: (error) => {},
                  from: "portfolio",
                });
              }
            });
          }
        },
      });
    }
  }

  callGetFamilyMemberAccessData({ onDataSuccess, onDataFail }) {
    let familyId;
    if (getDecodedToken()?.user_type === "employee") {
      familyId = UserStore?.userData?.family_id;
    } else {
      familyId = getDecodedToken()?.family_id;
    }
    this.getFamilyMemberAccessData({
      familyId,
      onSuccess: (data) => {
        const imageArr = {};
        data.forEach((eachClient) => {
          if (eachClient.client.profile_pic) {
            this.getImageFromAPI({
              path: eachClient.client.profile_pic,
              onSuccess: (imageBlob) => {
                getBlobToBase64(imageBlob).then((url) => {
                  let resImage = url;
                  imageArr[eachClient.client.user_id] = resImage;
                  this.familyMemberAccessImages = {
                    ...this.familyMemberAccessImages,
                    ...imageArr,
                  };
                });
              },
            });
          }
        });
        this.familyMemberAccessData = data;
        const decodedToken = getDecodedToken();
        //SETTINGS MENNU FILTER
        const newSettingsArr = settingsMenuDetails.filter((eachMenuDetail) => {
          if (
            eachMenuDetail.key === "family_member_access" ||
            eachMenuDetail.key === "liaison_office_access"
          ) {
            if (eachMenuDetail.key === "family_member_access" && !data.length) {
              return false;
            }
            if (
              eachMenuDetail.key === "liaison_office_access" &&
              decodedToken?.primary === "true"
            ) {
              return true;
            }
            return (
              decodedToken?.primary === "true" &&
              eachMenuDetail?.accessibleBy?.includes(decodedToken?.user_type)
            );
          }
          return eachMenuDetail?.accessibleBy?.includes(
            decodedToken?.user_type
          );
        });
        this.updateSettingsOptionsArr(newSettingsArr);
        UserStore.setPagesApiStatus(
          "HomePageApiStatus",
          "familyMemberAccessData",
          "success"
        );
        onDataSuccess(data);
      },
      onFail: (error) => {
        onDataFail(error);
      },
    });
  }

  callUpdateNotification() {
    let userId;
    if (getDecodedToken()?.user_type === "employee") {
      userId = UserStore?.userData?.user_id;
    } else {
      userId = getDecodedToken()?.user_id;
    }
    const getUpdatedNotification = () => (this.isNotification ? "0" : "1");

    this.updateNotification({
      clientId: userId,
      isNotification: getUpdatedNotification(),
      onSuccess: () => {
        this.getClientData({
          clientId: userId,
          onSuccess: (data) => {
            this.isNotification = Number(data.isNotification);
          },
        });
      },
    });
  }

  callInvestmentsHeldWith(updatedInvestmentsHeldWith) {
    let userId;
    if (getDecodedToken()?.user_type === "employee") {
      userId = UserStore?.userData?.user_id;
    } else {
      userId = getDecodedToken()?.user_id;
    }
    this.updateInvestmentsHeldWith({
      clientId: userId,
      InvestmentHeldWith: updatedInvestmentsHeldWith,
      onSuccess: () => {
        this.getClientData({
          clientId: userId,

          onSuccess: (data) => {
            this.investmentHeldWith = data.investmentHeldWith;
          },
        });
      },
      onFail: () => {
        AuthStore.updateLoadingFullScreen(false);
      },
    });
  }

  // Report Type Call
  callReportType(reportType) {
    const userId = getDecodedToken()?.user_id;
    this.updateReportType({
      clientId: userId,
      reportType: reportType,
      onSuccess: (data) => {},
      onFail: (err) => {},
    });
  }

  callgetImageFromAPI(path, successFunc) {
    this.getImageFromAPI({
      path,
      onSuccess: successFunc,
      onFail: (err) => {},
    });
  }

  callUpdateFamilyAccessData(payload) {
    const familyId = getDecodedToken()?.family_id;
    this.UpdateFamilyMemberAccessData({
      familyId,
      payload,
      onSuccess: () => {
        this.getFamilyMemberAccessData({
          familyId,
          onSuccess: (data) => {
            this.familyMemberAccessData = data;
          },
        });
      },
    });
  }

  callDeleteRegisteredDevice(deviceId) {
    const userId = getDecodedToken()?.user_id;
    this.deleteRegisteredDevice({
      deviceId,
      onSuccess: () => {
        this.getRegisteredDevices({
          clientId: userId,
          onSuccess: (data) => {
            this.registeredDevices = data;
          },
        });
      },
    });
  }

  callUpdateLaisonOfficerData(liaisonOfficerId, payload, successNavigation) {
    const userId = getDecodedToken()?.user_id;
    this.UpdateLaisonOfficerData({
      clientId: userId,
      liaisonOfficerId,
      payload,
      onSuccess: () => {
        this.getLaisonOfficersData({
          clientId: userId,
          onSuccess: (data) => {
            this.liaisonOfficerData = data[0];
            if (successNavigation) {
              successNavigation();
            }
          },
          loader: true,
        });
      },
      onFail: (error) => {
        AuthStore.updateLoadingForSettingsLO(false);
      },
    });
  }

  callDeleteLaisonOfficerData(liaisonOfficerId, successNavigation) {
    const userId = getDecodedToken()?.user_id;
    this.DeleteLaisonOfficerData({
      clientId: userId,
      liaisonOfficerId,
      onSuccess: () => {
        this.getLaisonOfficersData({
          clientId: userId,
          onSuccess: (data) => {
            this.liaisonOfficerData = data[0];
            if (successNavigation) {
              successNavigation();
            }
          },
          loader: true,
        });
      },
      onFail: () => {
        AuthStore.updateLoadingForSettingsLO(false);
      },
    });
  }

  callcreateLaisonOfficersData(payload, callbackFunc) {
    const userId = getDecodedToken()?.user_id;
    this.createLaisonOfficersData({
      clientId: userId,
      payload,
      onSuccess: () => {
        this.getLaisonOfficersData({
          clientId: userId,
          onSuccess: (data) => {
            const imageArr = {};
            if (data[0].profile.profile_pic) {
              this.getImageFromAPI({
                path: data[0].profile.profile_pic,
                onSuccess: (imageRawData) => {
                  getBlobToBase64(imageRawData).then((url) => {
                    let resImage = url;
                    imageArr[data[0].profile.user_id] = resImage;
                    this.profile = {
                      name: data[0].profile.profile_pic.slice(
                        data[0].profile.profile_pic.lastIndexOf("/") + 1
                      ),
                      size: getFileSize(imageRawData?.size),
                      exactSize: imageRawData?.size,
                      type: imageRawData?.type,
                      src: resImage,
                      file: imageRawData,
                    };
                    this.liaisonOfficerImages = {
                      ...this.liaisonOfficerImages,
                      ...imageArr,
                    };
                  });
                },
              });
            }
            data[0]?.accountAccess?.forEach((eachClient) => {
              if (eachClient.client.profile_pic) {
                this.getImageFromAPI({
                  path: eachClient.client.profile_pic,
                  onSuccess: (imageBlob) => {
                    getBlobToBase64(imageBlob).then((url) => {
                      let resImage = url;
                      imageArr[eachClient.client.user_id] = resImage;
                      this.liaisonOfficerImages = {
                        ...this.liaisonOfficerImages,
                        ...imageArr,
                      };
                    });
                  },
                });
              }
            });
            this.liaisonOfficerData = data[0];
            if (callbackFunc) {
              callbackFunc();
            }
          },
          loader: true,
        });
      },
      onFail: () => {
        AuthStore.updateLoadingForSettingsLO(false);
      },
    });
  }

  // functions to update mobx states
  // type-2 funcitons states from here.
  updateProfile(profile) {
    this.profile = profile;
  }
  updateProfilePic(profileUrl) {
    this.liaisonOfficerData = {
      ...this.liaisonOfficerData,
      profile: {
        ...this.liaisonOfficerData.profile,
        profile_pic: profileUrl,
      },
    };
  }
  removeProfilePhoto() {
    this.liaisonOfficerData.profile.profile_pic = "";
    this.addLiaisonOfficerUrl = "";
  }
  updateAddLiaisonOfficerUrl(url) {
    this.addLiaisonOfficerUrl = url;
  }
  setTempProfile(profile) {
    this.tempProfileForUpdate = profile;
  }
  updateLoginFromUserList(data) {
    this.loginFromUserList = data;
  }
  updateLoginFromCheckedIds(data) {
    this.loginFromCheckedIds = { ...this.loginFromCheckedIds, ...data };
  }
  updatebyDevicesFilterSelected(data) {
    this.byDevicesFilterSelected = data;
  }
  resetFilter() {
    const tempCheckIds = this.loginFromCheckedIds;
    for (let userId in tempCheckIds) {
      tempCheckIds[userId] = true;
    }
    this.loginFromCheckedIds = tempCheckIds;
    this.byDevicesFilterSelected = { apple: true, android: true, others: true };
  }
  updateSettingsOptionsArr(data) {
    this.settingsOptionsArr = data;
  }
  get isHydrated() {
    return isHydrated(this);
  }
  setSettingsStoreToIntialState() {
    this.profile = null;
    this.tempProfileForUpdate = null;
    this.familyMemberAccessData = null;
    this.familyMemberAccessImages = null;
    this.liaisonOfficerData = null;
    this.liaisonOfficerImages = null;
    this.addLiaisonOfficerUrl = "";
    this.registeredDevices = null;
    this.recentLogin = null;
    this.recentLoginImages = null;
    this.isNotification = "0";
    this.investmentHeldWith = null;
    this.isheldaway = null;
    this.report_type = 0;
    this.settingsOptionsArr = [];
    // manage devices filter states
    this.loginFromUserList = [];
    this.loginFromCheckedIds = {};
    this.byDevicesFilterSelected = { apple: true, android: true, others: true };
  }
  // type-3 funcitons states from here.
  //================= Family Member Access Apis =======================//

  // 1) get Family Member Access Data on mount
  getFamilyMemberAccessData({ familyId, onSuccess, onFail = () => {} }) {
    apiClient
      .get(`families/${familyId}/memberaccesscontrols`)
      .then(({ data }) => {
        AuthStore.updateLoadingFullScreen(false);
        onSuccess(data);
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        onFail(error);
      });
  }
  // 2) get family member image (common function to get images)
  getImageFromAPI({ path, onSuccess, onFail = () => {}, loader = true }) {
    plainApiClient
      .get(path, { responseType: "blob" })
      .then(({ data }) => {
        onSuccess(data);
        if (loader) AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        if (loader) AuthStore.updateLoadingFullScreen(false);
      });
  }
  // 3) update Family Member Access Data
  UpdateFamilyMemberAccessData({
    familyId,
    payload,
    onSuccess,
    onFail = () => {},
  }) {
    apiClient
      .put(`families/${familyId}/memberaccesscontrols`, payload)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  //================= Family Office Team Access Apis =======================//

  // 1) Get Family Office Team
  getLaisonOfficersData({ clientId, onSuccess, onFail, loader }) {
    if (loader) {
      AuthStore.updateLoadingForSettingsLO(true);
    }
    apiClient
      .get(`clients/${clientId}/laisonofficers`)
      .then(({ data }) => {
        onSuccess(data);
        if (loader) {
          AuthStore.updateLoadingFullScreen(false);
          AuthStore.updateLoadingForSettingsLO(false);
        }
      })
      .catch((error) => {
        onFail && onFail(error);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(false);
      });
  }

  // 2) Update Family Office Team Data
  UpdateLaisonOfficerData({
    clientId,
    liaisonOfficerId,
    payload,
    onSuccess,
    onFail,
  }) {
    AuthStore.updateLoadingForSettingsLO(true);
    apiClient
      .put(`clients/${clientId}/laisonofficers/${liaisonOfficerId}`, payload)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(true);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(false);
      });
  }
  // 3) Delete Family Office Team Data
  DeleteLaisonOfficerData({
    clientId,
    liaisonOfficerId,
    onSuccess,
    onFail = () => {},
  }) {
    AuthStore.updateLoadingForSettingsLO(true);
    apiClient
      .delete(`clients/${clientId}/laisonofficers/${liaisonOfficerId}`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(true);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(false);
      });
  }
  // 4) Create Family Office Team
  createLaisonOfficersData({
    clientId,
    payload,
    onSuccess,
    onFail = () => {},
  }) {
    AuthStore.updateLoadingForSettingsLO(true);
    apiClient
      .post(`clients/${clientId}/laisonofficers`, payload)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(true);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
        AuthStore.updateLoadingForSettingsLO(false);
      });
  }
  //================= Managed Devices Apis =======================//

  // 1) Get Registered Devices
  getRegisteredDevices({ clientId, onSuccess, onFail = () => {} }) {
    apiClient
      .get(`clients/${clientId}/registereddevices`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }
  // 2) Delete Registered Device
  deleteRegisteredDevice({ deviceId, onSuccess, onFail = () => {} }) {
    apiClient
      .delete(`registereddevices/${deviceId}`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }
  // 3) Get Recent Login
  getRecentLogin({ clientId, onSuccess, onFail = () => {} }) {
    apiClient
      .get(`clients/${clientId}/recentlogins`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }
  //================= Notification Settings Apis =======================//

  // 1) get client data for notification, investment held with
  getClientData({ clientId, onSuccess, onFail = () => {} }) {
    apiClient
      .get(`clients/${clientId}`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }
  // 2) update notification
  updateNotification({
    clientId,
    isNotification,
    onSuccess,
    onFail = () => {},
  }) {
    apiClient
      .put(`UpdateNotification/${clientId}?isNotification=${isNotification}`)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  //================= Investments Held With =======================//

  // 1) Update investments Held With API call
  updateInvestmentsHeldWith({
    clientId,
    InvestmentHeldWith,
    onSuccess,
    onFail,
  }) {
    apiClient
      .put(
        `UpdateInvestmentHeldWith/${clientId}?InvestmentHeldWith=${InvestmentHeldWith}`
      )
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  updateReportType({ clientId, reportType, onSuccess, onFail }) {
    apiClient
      .put(`UpdateReportType/${clientId}?ReportType=${reportType}`)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }
}
const Settings = new SettingsStore();
export default Settings;
